export class Dropdown {
  constructor(container, on) {
    this.container = container;
    this.button = null;
    this.items = [];
    this.active = false;
    this.selected = null;
    this.on = on || {};

    this.init();
  }

  init() {
    if (!this.container || !this.container instanceof Node) { return false; }
    this.button = this.container.querySelector('button');
    if (!this.button) { return false; }
    this.span = this.button.querySelector('span');
    this.items = Array.from(this.container.querySelectorAll('.dropdown__content a, .dropdown__content button'));

    const initEl = this.verifyHash();

    if (this.button && this.items.length > 0) {
      this.events();
    }

    this.triggerEvent('init', initEl);
  }

  events() {
    this.button.addEventListener('click', () => {
      this.toggleClass();
    });
    this.items.forEach(el => {
      el.addEventListener('click', () => {
        this.handleSelect(el);
      });
    });
  }

  toggleClass() {
    this.active ? this.hideDropdown() : this.showDropdown();
  }

  showDropdown() {
    this.button.classList.add('active');
    this.active = true;
    this.addOutsideClickEventListener()
    this.triggerEvent('open');
  }

  hideDropdown() {
    this.button.classList.remove('active');
    this.active = false;
    this.triggerEvent('close');
  }

  updateButton(el) {
    this.span.innerText = el.innerText;
    this.hideDropdown.call(this);
  }

  handleSelect(el) {
    this.update(el);
    this.updateButton(el);
    this.triggerEvent('change', el);
  }

  update(el) {
    this.selected = el;
    this.items.forEach(el => {
      el.classList.remove('active');
    });
    el.classList.add('active');
  }

  verifyHash() {
    if (location.hash) {
      const el = this.container.querySelector(`[href="${location.hash}"]`);
      if (el) {
        this.updateButton(el);
        this.update(el);
        return el;
      }
    }
    return false;
  }

  reset() {
    this.updateButton(this.items[0]);
    this.selected = null;
    this.items.forEach(el => {
      el.classList.remove('active');
    });
    this.triggerEvent('reset');
  }

  addOutsideClickEventListener() {
    document.addEventListener('click', event => { this.handleOusideClick(event)}, false);
  }

  removeOutsideClickEventListener() {
    document.removeEventListener('click', event => { this.handleOusideClick(event)}, false);
  }

  handleOusideClick(event) {
    if (this.container !== event.target && !this.container.contains(event.target)) {
      this.hideDropdown.call(this);
      this.removeOutsideClickEventListener();
    }
  }

  set(value) {
    const el = this.container.querySelector(`.dropdown__content a[data-value="${value}"], .dropdown__content button[data-value="${value}"]`);
    if (!el) console.error(`Dropdown error - ${value} not found.`);
    this.update(el);
    this.span.innerText = el.innerText;
    this.triggerEvent('change', el);
  }

  triggerEvent(type, arg) {
    if (this.on[type] && typeof this.on[type] === 'function') {
      this.on[type](arg);
    }
  }
}
